import { VirtualRealityIcon } from './VirtualRealityIcon';

/**
 * author: GreenTurtwig
 * id AE3F0BAE-DE0A-4BFE-82B6-3268D1B21006
 * name virtual-reality
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/virtual-reality.svg
 * tags
 */
export const VrIcon = VirtualRealityIcon;
export default VrIcon